<script>

import { inertia, page } from '@inertiajs/inertia-svelte';
import { modalStyle, trans } from '@/utils';
import { createEventDispatcher } from 'svelte';
import Gallery from './Gallery.svelte';
import CityChart from './CityChart.svelte';

export let city;

export let closed = true;
export let principles = [];

const dispatch = createEventDispatcher();

const close = () => {
    dispatch('close');
}

let info; // div

let nf = new Intl.NumberFormat('es-ES');

$: {
    if (closed) {
        modalStyle('closed');
    } else {
        if (info) info.scrollTop = 0;
        modalStyle('open');
    }
}

$: url = city ? $page.props.url + `?city_id=${city.id}` : $page.props.url;
</script>


<div class="overlay" class:closed on:click={close}></div>
<div id="info" bind:this={info} class:closed class="bg-white city_modal d-flex flex-column" style="z-index: 9992;">



    {#if city}

    <div class="bg-primary p-4">
      <div class="position-relative">

        <div class="ms-auto d-lg-flex justify-content-between pb-2 mb-3 border-bottom share_block city_info d-none">
          <a href="http://www.twitter.com/share?url={encodeURIComponent(url)}" target="_blank">
            <i class="fa-brands fa-twitter"></i>
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u={encodeURIComponent(url)}" target="_blank">
            <i class="fa-brands fa-facebook"></i>
          </a>
          <a href="https://www.linkedin.com/shareArticle?mini=true&url={encodeURIComponent(url)}" target="_blank">
            <i class="fa-brands fa-linkedin"></i>
          </a>
          <a href="mailto:?subject={encodeURIComponent(`GOUAI's Atlas of Urban AI: ${city.name}`)}&body={encodeURIComponent(url)}">
            <i class="fa-regular fa-envelope"></i>
          </a>
          <div class="border-end"></div>
          <div class="position-relative">
          <a href="/contribute/">
            {trans('link_contribute')}
          </a>
          </div>

          </div>

        <h2 class="fs-3 fw-light">{city.name}</h2>
        <button type="button" class="btn position-absolute text-white close_modal fs-4" on:click={close}>
          <i class="fa-light fa-xmark"></i>
        </button>
      </div>
      <div class="mt-lg-5 mt-3 d-lg-flex flex-wrap justify-content-between">
        <div class="flex-fill justify-content-between d-flex d-lg-block">
          <div class="small text-uppercase">
            {trans('population')}{#if city.population_year}<sup>*</sup>{/if}:
          </div>
          <div>
           {nf.format(city.population)}
         </div>
        </div>
        <div class="flex-fill justify-content-between d-flex d-lg-block">
          {#if city.gdp}
          <div class="small text-uppercase">
            {trans('income_per_capita')}{#if city.gdp_year}<sup>**</sup>{/if}:
          </div>
          <div>
            {nf.format(city.gdp)} €
          </div>
          {/if}
        </div>
        <div class="flex-fill justify-content-between d-flex d-lg-block">
          <div class="small text-uppercase">
            {trans('ai_strategy')}:
          </div>
          <div>
            {city.ai ? trans('ai_strategy_yes') : trans('ai_strategy_no')}
          </div>
        </div>
        <div class="flex-fill justify-content-between d-flex d-lg-block">
          <div class="small text-uppercase">
            {trans('cc4dr')}:
          </div>
          <div>
            {city.cc4dr ? trans('cc4dr_yes') : trans('cc4dr_no')}
          </div>
        </div>
      </div>
    </div>


    <div class="p-4 p-lg-5 text-dark">
      <div class="d-flex">
        <div class="fs-2 fw-light text-primary me-auto">{trans('title_initiatives')} ({city.projects.length}/{city.num_projects})</div>
        <div>
          <CityChart {principles} projects={city.projects} />
        </div>
      </div>

      <div class="accordion accordion-flush" id="acc-projects">
        {#each city.projects as p (p.id)}
        <div class="accordion-item">
          <div class="accordion-header position-relative" id="acc-header-{p.id}">
            <button class="accordion-button collapsed m-0 p-0 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#acc-project-{p.id}" aria-expanded="false" aria-controls="acc-project-{p.id}">
              <div class="title_project">
                {p.name}
              </div>
              <div class="dot_wrap">
                {#each p.principles as pri (pri.id)}
                <span data-tooltip="{pri.name}" class="d-inline-block"><i class="fa-solid fa-circle-small ms-2" style="color:{pri.color}"></i></span>
                {/each}
              </div>
            </button>

          </div>
          <div id="acc-project-{p.id}" class="accordion-collapse collapse" aria-labelledby="acc-header-{p.id}" data-bs-parent="#acc-projects">
            <div class="accordion-body p-0 pt-3">

                <div class="mb-5">
                  <p>
                       {@html p.description}
                  </p>
                </div>

                <div class="">

                  <div class="row">

                    {#if p.sectors.length}
                    <div class="col-md-6 mb-4">
                      <div class="small text-uppercase text-primary">
                        {trans('sector')}
                      </div>
                      <div>

                        <div class="accordion" id="infoSectors">
                          {#each p.sectors as sec (sec.id)}
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="infoSectorHead{sec.id}">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#infoSectorDetail{sec.id}" aria-expanded="false" aria-controls="infoSectorDetail{sec.id}">
                                {sec.name}
                              </button>
                            </h2>
                            <div id="infoSectorDetail{sec.id}" class="accordion-collapse collapse" aria-labelledby="infoSectorHead{sec.id}" data-bs-parent="#infoSectors">
                              <div class="accordion-body">
                                {#if sec.children.length}
                                <ul class="list-unstyled list-subsector">
                                  {#each sec.children as sub (sub.id)}
                                  <li>{sub.name}</li>
                                  {/each}
                                </ul>
                                {/if}
                              </div>
                            </div>
                          </div>
                          {/each}
                        </div>

                        <!--
                        <ul class="list-unstyled list-sector">
                          {#each p.sectors as sec (sec.id)}
                          <li>{sec.name}
                            {#if sec.children.length}
                            <ul class="list-unstyled list-subsector">
                              {#each sec.children as sub (sub.id)}
                              <li>{sub.name}</li>
                              {/each}
                            </ul>
                            {/if}
                          </li>
                          {/each}
                        </ul>
                        -->
                      </div>
                    </div>
                    {/if}

                    {#if p.principles.length}
                    <div class="col-md-6 mb-4">
                      <div class="small text-uppercase text-primary">
                        {trans('ai_principles')}
                      </div>
                      <div>
                        <ul class="list-unstyled">
                        {#each p.principles as pri (pri.id)}
                        <li>{pri.name}</li>
                        {/each}
                        </ul>
                      </div>
                    </div>
                    {/if}

                  </div>
                  <div class="row">

                    <div class="col-md-4 mb-4">
                      <div class="small text-uppercase text-primary">
                        {trans('implementation_phase')}
                      </div>
                      {p.status || 'N/A'}
                    </div>
                    <div class="col-md-4 mb-4">
                      <div class="small text-uppercase text-primary">
                        {trans('type_of_initiative')}
                      </div>
                      {p.type}
                    </div>
                    <div class="col-md-4 mb-4">
                      <div class="small text-uppercase text-primary">
                        {trans('initiation_date')}
                      </div>
                      {p.init_y || 'N/A'}
                    </div>
                  </div>

                  <div class="row">
                    {#if p.urls.length}
                    <div class="col-md-{p.videos.length ? '6' : '12'} mb-4">
                      <div>
                        <div class="small text-uppercase text-primary">
                          {trans('relevant_sources')}
                        </div>
                        <ul class="list-unstyled">
                        {#each p.urls as url, i (url)}
                        {@const a = url.split('|')}
                        <li><a href="{a[0]}" target="_blank">{a[1] || `Source ${i+1}`}</a></li>
                        {/each}
                        </ul>
                      </div>
                    </div>
                    {/if}
                    {#if p.videos.length}
                    <div class="col-md-{p.urls.length ? '6' : '12'} mb-4">
                      <div>
                        <div class="small text-uppercase text-primary">
                          {trans('videos')}
                        </div>
                        <ul class="list-unstyled">
                          {#each p.videos as url, i (url)}
                          {@const a = url.split('|')}
                          <li><a href="{a[0]}" target="_blank">{a[1] || `Video ${i+1}`}</a></li>
                          {/each}
                        </ul>
                      </div>
                    </div>
                    {/if}
                  </div>

                </div>


                {#if p.contact_person || p.email}
                <div class="mb-5">
                  <div>
                    <div class="small text-uppercase text-primary">
                      {trans('contact_details')}
                    </div>
                    {#if p.contact_person}
                    <div>
                      {p.contact_person}
                    </div>
                    {/if}
                    {#if p.email}
                    <div>
                      {p.email}
                    </div>
                    {/if}
                  </div>
                </div>
                {/if}

                {#if p.images.length}
                <div class="mb-5">
                  <div>
                    <div class="small text-uppercase text-primary">
                      {trans('images')}
                    </div>
                    <div>

                      <Gallery id={p.id} images={p.images} />

                    </div>
                  </div>
                </div>
                {/if}


            </div>
          </div>
        </div>
        {/each}
      </div>

    </div>

    <div class="p-4 p-lg-5 small text-dark city_ref mt-auto">
      <div class="mb-4">
        {#if city.population_year}
        <div>
          <span class="d-inline-block" style="width:24px">*</span> {city.population_year}
        </div>
        {/if}
        {#if city.gdp_year}
        <div>
          <span class="d-inline-block" style="width:24px">**</span> {city.gdp_year}
        </div>
        {/if}
      </div>
      <div class="d-flex flex-wrap">
        {#each principles as pri (pri.id)}
        <div class="me-2 mb-1">
          <i class="fa-solid fa-circle-small" style="color:{pri.color}"></i>
          {pri.name}
        </div>
        {/each}
      </div>
    </div>

    {/if}
</div>
